module.exports = __webpack_public_path__ + "img/logoRecapt.3946ff86.png";